export const reservationTypes = {
  hotel: "HOTEL",
  flight: "FLIGHT",
  dynamicPackage: "DP",
};
